/**
 * Utils module
 * Write any (default) function
 */
const Utils = {

    /**
     * random Uuid generator for Javascript (RFC4122 compliant)
     * https://gist.github.com/jcxplorer/823878
     *
     * @returns {string} uuid
     */
    uuid() {
        let uuid = '',
            i,
            random;

        for (i = 0; i < 32; i++) {
            random = Math.random() * 16 | 0;

            if (i === 8 || i === 12 || i === 16 || i === 20) {
                uuid += '-';
            }
            uuid += (i === 12 ? 4 : (i === 16 ? (random & 3 | 8) : random)).toString(16); // eslint-disable-line no-nested-ternary
        }
        return uuid;
    },

};

Utils.MobileOS = {
    ANDROID: 'android',
    IOS: 'ios',
    WINDOWS_PHONE: 'windows_phone'
};

export default Utils;
